export default function Security() {
  return (
    <section id="security" className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-purple-800 to-blue-900"></div>
      
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block px-4 py-2 border-2 border-white/30 text-white text-xs font-semibold rounded-full mb-6 uppercase tracking-wider">
              Security First
            </div>
            <h2 className="text-6xl font-bold text-white mb-12 leading-tight">
              Your Data<br />Stays Yours
            </h2>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-1">AES-256 Encryption</h3>
                  <p className="text-gray-300 text-base">Bank-level encryption that keeps your data completely secure from prying eyes and cyber threats.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-1">Zero-Knowledge DNS</h3>
                  <p className="text-gray-300 text-base">Our DNS servers don't store any information about your browsing activity or personal data.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-lg"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-1">Automatic Kill Switch</h3>
                  <p className="text-gray-300 text-base">Instantly blocks all internet traffic if your VPN connection drops, preventing data leaks.</p>
                </div>
              </div>
            </div>

            <button className="mt-10 px-8 py-3 border-2 border-white text-white text-base font-semibold rounded-full hover:bg-white hover:text-purple-900 transition-all whitespace-nowrap cursor-pointer">
              Learn More About Security
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>

          <div className="flex justify-center">
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/2d9bc8f0f2bef5d129105c0e4d47d645.jpg" 
                alt="Security Shield" 
                className="w-full max-w-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
